import { inject, Injectable } from "@angular/core";
import { first, map, of, shareReplay } from "rxjs";
import { GraphqlService } from "@ubisolutions/core";
import { MeGraphql } from "@shared/core/services/user-services.graphql";

/**
 * The full MeGraphql result (userName, client…). The library's UserInfoService runs the
 * same query (CURRENT_USER_QUERY) but only types the fields it needs itself.
 */
@Injectable({
    providedIn: "root",
})
export class UserDetailsService {
    private readonly graphqlService = inject(GraphqlService);

    private readonly userDetails$ = this.graphqlService.query(MeGraphql).observeWith(of({})).pipe(
        map(query => query.me),
        shareReplay(1),
    );

    getUserDetails() {
        return this.userDetails$.pipe(
            first(),
        );
    }
}
